import {
  isTokenSuspiciousCheck,
  suspiciousCheckData,
} from '../../Wallets/labels';
import Tooltip from 'modules/shared-components/tooltip';
import { ColumnsProps } from '../columns';
import { hotTokenDataMapping } from '../hotTokenDataMapping';
import { useMemo } from 'react';
import { PerformanceStyle } from '../../../../components/alerts/performanceStyle';

export default function MarketCapColumn({ data, tokenStats }: ColumnsProps) {
  const mappedStats = useMemo(() => {
    return hotTokenDataMapping(tokenStats, data);
  }, [tokenStats, data]);

  const marketCap = mappedStats.marketCap;

  return (
    <div
      className={
        isTokenSuspiciousCheck(suspiciousCheckData(tokenStats, data))
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      {marketCap ? (
        <Tooltip text="Fully diluted Market Cap.">
          <div className="text-xs">
            <PerformanceStyle
              noPnl={true}
              className="text-xs"
              pnl={marketCap.toString()}
            />
          </div>
        </Tooltip>
      ) : (
        <div className="text-xs">--</div>
      )}
    </div>
  );
}
